import React from 'react';
import { RadioGroup } from 'components/UI/V3/Forms/RadioGroup/RadioGroup';
import { SESSION_BOOKING_TYPES } from 'model/Service';
import styles from './BookingTypeSection.module.scss';

interface BookingTypeSectionProps {
    bookingType: string;
    onChange: (bookingType: string) => void;
}

export const BookingTypeSection: React.FC<BookingTypeSectionProps> = ({ bookingType, onChange }) => {
    const options = [
        {
            value: SESSION_BOOKING_TYPES.PRIVATE_SESSION,
            inlineLabel: 'Private Session'
            //description: 'One-on-one training with a single pet owner'
        },
        {
            value: SESSION_BOOKING_TYPES.GROUP_SESSION,
            inlineLabel: 'Group Session'
            //description: 'Training with multiple pet owners in a group setting'
        }
    ];

    return (
        <div className={styles.container}>
            <RadioGroup
                label="Booking Type"
                value={bookingType}
                options={options}
                onChange={onChange}
            />
        </div>
    );
};
